import gql from 'graphql-tag';

// マスタ管理 ゴルフグループ
export const GET_GOLFGROUP = gql`
    query {
        getGolfGroupByMaster{
            golf_group_code
            golf_group_name
            point_use_type
            point_remainder_type
            point_type_name
            remainder
        }
    }
`;

export const REGISTER_GOLFGROUP = gql`
    mutation (
        $golf_group_code: String!
        $golf_group_name: String!
        $point_use_type: Int!
        $point_remainder_type: Int!
    ) {
        RegisterGolfGroup(
            golf_group_code: $golf_group_code
            golf_group_name: $golf_group_name
            point_use_type:  $point_use_type
            point_remainder_type: $point_remainder_type
        ) {
            result
        }
    }
`;

export const UPDATE_GOLFGROUP = gql`
    mutation (
        $golf_group_code: String!
        $golf_group_name: String!
        $point_use_type: Int!
        $point_remainder_type: Int!
    ) {
        UpdateGolfGroup (
            golf_group_code: $golf_group_code
            golf_group_name: $golf_group_name
            point_use_type:  $point_use_type
            point_remainder_type: $point_remainder_type
        ) {
            result
        }
    }
`;

export const GET_FLAG_FROM_CODE_MASTER = gql`
    query(
        $code_key: String!
        $default_display: Int!
    ){
        GetCodeList(
            code_key: $code_key
            default_display: $default_display
        ){
            CodeList{
                code
                code_name
            }
        }
    }
`;

// マスタ管理 ゴルフ場
export const GET_GOLFCOURSE = gql`
    query (
        $golf_group_code: String!
        $limit_rows: Int
        $begin_row: Int
    ) {
        getGolfCourseByMaster (
            golf_group_code: $golf_group_code
            limit_rows: $limit_rows
            begin_row: $begin_row
        ) {
            GolfCourse{
                golf_code
                golf_group_code
                golf_name
                golu_kana
                zip_code
                prefecture_name
                municipality_name
                local_name
                building_name
                telephone
                fax
                golf_course_img_path
                point_grant_type
                cell_link_type
                display_course
                company_name
                valid_flag
                play_together_fixed_deadline
            }
            count
        }
    }
`;

export const GET_GOLFCOURSE_FOR_SYSTEM_ADMIN = gql`
    query(
        $golf_group_code: String!
    ) {
        getGolfCourseForSystemAdmin (
            golf_group_code: $golf_group_code
        ) {
            golf_code
            golf_name
        }
    }`;

export const REGISTER_GOLFCOURSE = gql`
    mutation (
        $golf_code: String!
        $golf_group_code: String!
        $golf_name: String!
        $golu_kana: String!
        $zip_code: String!
        $prefecture_name: String!
        $municipality_name: String!
        $local_name: String
        $building_name: String
        $telephone: String!
        $fax: String
        $golf_course_img_path: String
        $point_grant_type: Int
        $cell_link_type: Int
        $display_course: Int
        $company_name: String
    ) {
        registerGolfCourse (
            golf_code: $golf_code
            golf_group_code: $golf_group_code
            golf_name: $golf_name
            golu_kana: $golu_kana
            zip_code: $zip_code
            prefecture_name: $prefecture_name
            municipality_name: $municipality_name
            local_name: $local_name
            building_name: $building_name
            telephone: $telephone
            fax: $fax
            golf_course_img_path: $golf_course_img_path
            point_grant_type: $point_grant_type
            cell_link_type: $cell_link_type
            display_course: $display_course
            company_name: $company_name
        ) {
            result
        }
    }
`;

export const UPDATE_GOLFCOURSE = gql`
    mutation (
        $golf_code: String!
        $golf_name: String!
        $golu_kana: String!
        $zip_code: String!
        $prefecture_name: String!
        $municipality_name: String!
        $local_name: String
        $building_name: String
        $telephone: String!
        $fax: String
        $golf_course_img_path: String
        $point_grant_type: Int
        $cell_link_type: Int
        $display_course: Int
        $company_name: String
        $valid_flag: Int!
    ) {
        updateGolfCourse(
            golf_code: $golf_code
            golf_name: $golf_name
            golu_kana: $golu_kana
            zip_code: $zip_code
            prefecture_name: $prefecture_name
            municipality_name: $municipality_name
            local_name: $local_name
            building_name: $building_name
            telephone: $telephone
            fax: $fax
            golf_course_img_path: $golf_course_img_path
            point_grant_type: $point_grant_type
            cell_link_type: $cell_link_type
            display_course: $display_course
            valid_flag: $valid_flag
            company_name: $company_name
        ) {
            result
        }
    }
`;

export const DELETE_GOLFCOURSE = gql`
    mutation (
        $golf_code: String!
    ) {
        deleteGolfCourse(
            golf_code: $golf_code
        ) {
            result
        }
    }
`;

// マスタ管理 ポイント区分
export const GET_POINT_TYPE = gql`
    query {
        getPointType {
            id
            point_type
            point_type_name
            point_type_display
            detail
        }
    }
`;

export const UPDATE_POINT_TYPE = gql`
    mutation(
        $id: ID!
        $point_type_display: String!
        $detail: String
    ){
        UpdatePointType(
            id: $id
            point_type_display: $point_type_display
            detail: $detail
        ){
            result
        }
    }
`;

// マスタ管理 退会理由
export const WITH_DRAWAL_REASON = gql`
  query (
      $begin_row: Int
      $limit_rows: Int
  ){
    getWithdrawalReasonCheckbox(
        begin_row: $begin_row
        limit_rows: $limit_rows
    ){
        WithdrawalReasonCheckboxList{
            id
            reason
            valid_flag
        }
        count
    }
  }
`;

export const REGISTER_WITH_DRAWAL_REASON = gql`
  mutation(
    $reason: String!
  ){
    registerWithdrawalReasonCheckbox(
      reason: $reason
    ){
      result
    }
  }
`;

export const UPDATE_WITH_DRAWAL_REASON = gql`
  mutation(
    $id: ID!
    $reason: String!
    $valid_flag: Int!
  ){
    updateWithdrawalReasonCheckbox(
      id: $id
      reason: $reason
      valid_flag: $valid_flag
    ){
      result
    }
  }
`;

export const DELETE_WITH_DRAWAL_REASON = gql`
  mutation(
    $id: ID!
  ){
    deleteWithdrawalReasonCheckbox(
      id: $id
    ){
      result
    }
  }
`;

// マスタ管理 定型文
export const GET_TEMPLATE_LIST = gql`
    query{
        getTemplateMaster{
            code
            code_name
            subject
            template
        }
    }
`;

export const REGISTER_TEMPLATE = gql`
    mutation(
        $golf_group_code: String!
        $template_code: String!
        $template_name: String!
        $subject: String!
        $template: String!
    ){
        registerTemplateMaster(
            golf_group_code: $golf_group_code
            template_code: $template_code
            template_name: $template_name
            subject: $subject
            template: $template
        ){
            result
        }
    }
`;

export const UPDATE_TEMPLATE = gql`
    mutation(
        $id: ID!
        $subject: String!
        $template: String!
    ){
        updateTemplateMaster(
            id: $id
            subject: $subject
            template: $template
        ){
            result
        }
    }
`;
